import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import { Row } from 'reactstrap';

import env from 'Env';
import HitCard from 'Components/Cards/HitCard';
import ProductCarousel from 'Components/HomePage/ProductCarousel';
import useViewport from 'Hooks/useViewport';
import BrowseButton from 'Components/Utility/BrowseButton';

const PRODUCT_DLC_PAGE_THRESHOLD = env.productDlcPageThreshold;

const messages = defineMessages({
  viewAllTitle: {
    id: 'carousel.related.viewall',
    defaultMessage: 'View all DLC',
  },
});

const CarouselRelatedProducts = ({
  product,
  allHits,
  crossPromoteDlcSection,
}) => {
  const { formatMessage } = useIntl();
  const { base_game: baseGame } = product;
  const { isAboveSm } = useViewport();

  const productCrossPromotedHits = product?.crossPromotedHits || [];
  const productRelatedHits = product?.relatedHits || [];
  let relatedHits = crossPromoteDlcSection ? productCrossPromotedHits : productRelatedHits;

  if (allHits) relatedHits = productCrossPromotedHits.concat(productRelatedHits);

  if (!relatedHits || relatedHits.length === 0) return false;

  if (isAboveSm) return false;

  let viewAllLink = `${product.type}/${product.slug}/dlc`;

  const dlcCountThreshold = product.type === 'dlc' ? PRODUCT_DLC_PAGE_THRESHOLD - 1 : PRODUCT_DLC_PAGE_THRESHOLD;

  const dlc = product.relatedHits && product.relatedHits.filter(h => h.type === 'dlc');

  if ((dlc || []).length < dlcCountThreshold) {
    viewAllLink = null;
  }

  return (
    <section className="CarouselRelatedProducts page-section-margin">
      <div className="section-heading-container">
        <h2 className="section-title">
          {baseGame && product.type !== 'dlc' && !crossPromoteDlcSection &&
            <FormattedMessage id="carousel.related.title.dlc.base" defaultMessage="DLC for {gameName}" values={{ gameName: baseGame.name }} />
          }

          {baseGame && product.type === 'dlc' && !crossPromoteDlcSection &&
            <FormattedMessage id="carousel.related.title.dlc-game-name.base" defaultMessage="Other DLC for {gameName}" values={{ gameName: baseGame.name }} />
          }

          {!baseGame && product.type !== 'dlc' && !crossPromoteDlcSection &&
            <FormattedMessage id="carousel.related.title.dlc" defaultMessage="DLC for this game" />
          }

          {!baseGame && product.type === 'dlc' && !crossPromoteDlcSection &&
            <FormattedMessage id="carousel.related.title.dlc-game-name" defaultMessage="Other DLC for this game" />
          }

          {crossPromoteDlcSection && baseGame &&
            <FormattedMessage id="carousel.related.title.newdlcforbasegame" defaultMessage="New DLC for {gameName}" values={{ gameName: baseGame.name }} />
          }

          {crossPromoteDlcSection && !baseGame &&
            <FormattedMessage id="carousel.related.title.newdlcfor" defaultMessage="New DLC for this game" />
          }
        </h2>
        {!!viewAllLink && <BrowseButton className={'view-all-btn'} location={viewAllLink} />}
      </div>
      {relatedHits.length < 3 &&
        <Row className="recommendation-container">
          {relatedHits && relatedHits.slice(0, 2).map(hit =>
            <HitCard
              lazy
              key={hit.objectID}
              hit={hit}
            />,
          )}
        </Row>
      }

      {relatedHits.length >= 3 &&
        <ProductCarousel
          resetCarousel
          slidesToShow={isAboveSm ? 4 : 3}
          hitData={relatedHits.slice(0, 12)}
          viewAllTitle={formatMessage(messages.viewAllTitle)}
          viewAllLocation={viewAllLink}
        />
      }
    </section>
  );
};

CarouselRelatedProducts.propTypes = {
  product: PropTypes.object,
  allHits: PropTypes.bool,
  crossPromoteDlcSection: PropTypes.bool,
};

CarouselRelatedProducts.defaultProps = {
  product: null,
  allHits: false,
  crossPromoteDlcSection: false,
};

export default CarouselRelatedProducts;
